<template>
    <div>
        <p>ProofreadingPal allows only one sample per customer or household. In order to prevent free sample abuse, please verify your phone number.</p>
        <div class="formBlock formBlockDouble">
            <div class="formRow container">
                <div class="col col-2">
                    <div style="position:relative;width: 380px;max-width: 100%;">
                        <vue-country-code
                            style="position:absolute;right:5px;border:none;top:5px;background:#fff;"
                            @onSelect="onSelect"
                            :defaultCountry="this.SelectedDataChild.countryShort"
                            :preferredCountries="['us']">
                        </vue-country-code>
                        <input type="text" :value=country disabled class="formSelect bfh-countries" style="background:#fff;" />
                    </div>
                </div>
                <div class="col col-2">
                    <div style="position:relative;width: 380px;max-width: 100%;">
                    <input type="text" placeholder="*Cell/Phone" class="formText bfh-phone"
                        style="padding-left:55px;" 
                        onkeyup="this.value=this.value.replace(/\D/g,'')"
                        v-model="SelectedDataChild.phone"
                        maxlength="12"
                        @input="$emit('updateSampleData', SelectedDataChild)"
                     />
                    <span style="position:absolute;left:15px;border:none;top:10px;background:none;">
                        {{countryCode}}
                    </span> 
                    </div>
                    <div class="step3RightTxtNote" v-if="buttonName != 'Call Me'">Enter your phone number and we'll text you a verification code.</div>
                    <div class="step3RightTxtNote" v-if="buttonName == 'Call Me'">Enter your phone number and we'll call you with a verification code.</div>
                </div>
                
            </div>
            <div class="formRow container">
                <div class="col col-2" style="text-align:center;">
                    <img 
                        v-if="buttonName != 'Call Me'"
                        :src="siteUrl + 'imgs/two-factor-sms.png'" 
                        alt="Two Factor Validation"
                     />
                     <img 
                        v-if="buttonName == 'Call Me'"
                        :src="siteUrl + 'imgs/two-factor-call.png'" 
                        alt="Two Factor Validation"
                     />
                </div>
                <div class="col col-2" style='margin-top:40px;'>
                    <input type="hidden" name="transactionid" value="<?php echo $transaction_id; ?>" />
                    <input type="hidden" name="action" id="twilioAction" value="text" />
                    <input type="submit" :value="buttonName" class="button button-blue"
                        @click="$emit('moveToStep', [2,3])"
                     />
                </div>
            </div>
            <div class="formRow container">
                <div class="col col-2" style="text-align:center;">
                    &nbsp;
                </div>
                <div class="col col-2">
                    <p>Or we can <a href="javascript:void(0)" @click="verificationChange()">{{linkText}}</a>.</p>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
import VueCountryCode from "vue-country-code";

export default {
    components: {
        VueCountryCode,
    },
    props: {
        SelectedData: Object,
    },
    data: function() {
        return {
            SelectedDataChild: this.SelectedData,
            country: 'United States',
            phone: '',
            countryCode: '+1',
            buttonName: 'Text Me',
            linkText: 'call you, instead',
        }
    },
    mounted: function() {
        this.$nextTick(function() {
            this.$emit('loaded', true);
            if(this.SelectedDataChild.verification == 'call') {
                this.buttonName = 'Call Me';
                this.linkText = 'text you, instead';
            } else {
                this.buttonName = 'Text Me';
                this.linkText = 'call you, instead';
            }
        });
    },
    methods: {
        verificationChange() {
            console.log(this.SelectedDataChild.verification);
            if(this.SelectedDataChild.verification == 'text') {
                this.SelectedDataChild.verification = 'call';
                this.SelectedDataChild.verification1 = 'text';
                this.buttonName = 'Call Me';
                this.linkText = 'text you, instead';
            } else {
                this.SelectedDataChild.verification = 'text';
                this.SelectedDataChild.verification1 = 'call';
                this.buttonName = 'Text Me';
                this.linkText = 'call you, instead';
            }
            this.$emit('updateSampleData', this.SelectedDataChild);
        },
        onSelect({name, iso2, dialCode}) {
            this.country = name;
            this.countryCode = '+'+dialCode;
            this.SelectedDataChild.countryCode = this.countryCode;
            this.SelectedDataChild.country = this.country;
            this.SelectedDataChild.countryShort = iso2;
            this.$emit('updateSampleData', this.SelectedDataChild);
        },
  },
}
</script>

<style>
.vue-country-select ul li::before {
    display:none;
}
.vue-country-select .dropdown-list {
    left: auto;
    right: -1px;
    max-width: 300px;
}
</style>